var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('van-field',{attrs:{"is-link":"","readonly":"","label":"证明申请"},on:{"click":function($event){return _vm.goNav('certificationApplicationDetail')}}}),_c('van-field',{attrs:{"is-link":"","readonly":"","label":"申请记录"},on:{"click":function($event){return _vm.goNav('certificationApplicationRecords')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }